export default "__VITE_ASSET__Ahf_m420__"